<template>
    <div>
        <a v-if="ad.link != null" :href="ad.link" :title="ad.name" target="_blank">
            <img :src="this.baseUrl + ad.advert_image_url" class="w-100" :alt="ad.name" />
        </a>
        <img v-else :src="this.baseUrl + ad.advert_image_url" class="w-100" :alt="ad.name" />
    </div>
</template>

<script>
    export default {
        props: ['ad']
    }
</script>

<style lang="scss" scoped>

</style>